/* Kherajani Shopping & Support Assistant.
   Honest by design: this is NOT a language model. It is a rule-based helper that answers only from
   (a) the live Shopify catalogue (predictive search, the product's own JSON, Shopify's related-products feed, the visitor's own cart) and
   (b) a short list of confirmed store facts. Anything else is handed to a person on WhatsApp.
   It cannot see or change orders, and it never invents prices, stock, specs, delivery times, warranty terms or offers.
   Nothing is stored. The only data sent anywhere is the visitor's own query, to this store's own Shopify endpoints. */
(function () {
  'use strict';
  var root = document.querySelector('[data-khc-ai]');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var fab = root.querySelector('.khc-assist__fab');
  var panel = root.querySelector('.khc-assist__panel');
  var hd = root.querySelector('.khc-ai__hd');
  var body = root.querySelector('[data-ai-body]');
  var home = root.querySelector('[data-ai-home]');
  var homeForm = root.querySelector('[data-ai-home-form]');
  var homeInput = root.querySelector('[data-ai-home-input]');
  var pdpSection = root.querySelector('[data-ai-pdp-section]');
  var log = root.querySelector('[data-ai-log]');
  var form = root.querySelector('[data-ai-form]');
  var input = root.querySelector('[data-ai-input]');
  var chipsBox = root.querySelector('[data-ai-chips]');
  var minBtn = root.querySelector('[data-ai-min]');
  var budgetBtn = root.querySelector('[data-ai-budget]');
  var compareIntroBtn = root.querySelector('[data-ai-compare-intro]');
  var compareBar = root.querySelector('[data-ai-comparebar]');
  var compareCount = root.querySelector('[data-ai-comparecount]');
  var compareGoBtn = root.querySelector('[data-ai-comparego]');
  var compareClearBtn = root.querySelector('[data-ai-compareclear]');
  var WA = root.getAttribute('data-wa') || '';
  var WA_SHOW = root.getAttribute('data-wa-show') || '';
  var CONTACT = root.getAttribute('data-contact') || '/pages/contact';
  var SEARCH = root.getAttribute('data-search') || '/search';
  var CUR = root.getAttribute('data-cur') || 'AED';
  var ADDRESS = root.getAttribute('data-address') || '';
  var EMAIL = root.getAttribute('data-email') || '';
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var CHECKOUT_URL = CART_URL.replace(/cart$/, 'checkout');
  var lastQuery = '';
  var busy = false;
  var pdpCache = null;
  var compareSet = [];

  /* ---------- small helpers ---------- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var p = n.toFixed(2).split('.');
    var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = p[1] === '00' ? i : i + '.' + p[1];
    return CUR === 'AED' ? '⃃ ' + amt : CUR + ' ' + amt;
  }
  function shortTitle(t) {
    t = String(t || '').replace(/\s+/g, ' ').trim();
    if (t.length <= 62) return t;
    var cut = t.slice(0, 62), sp = cut.lastIndexOf(' ');
    return (sp > 30 ? cut.slice(0, sp) : cut) + '…';
  }
  function scroll() { log.scrollTop = log.scrollHeight; }
  function bot(nodes) {
    var b = el('div', { class: 'khc-ai__m khc-ai__m--bot' }, [].concat(nodes));
    log.appendChild(b); scroll(); return b;
  }
  function you(text) { log.appendChild(el('div', { class: 'khc-ai__m khc-ai__m--you', text: text })); scroll(); }
  function p(text) { return el('p', { text: text }); }
  function drop(n) { if (n && n.parentNode) n.parentNode.removeChild(n); }
  function waLink(text) { return WA + (WA.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(text); }
  function getJSON(url) { return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }

  /* ---------- home / conversation view switching ---------- */
  function showHome() { home.hidden = false; log.hidden = true; chipsBox.hidden = true; }
  function showLog() { home.hidden = true; log.hidden = false; chipsBox.hidden = false; }

  function handoff(extra) {
    var msg = 'Hello Kherajani Computers, I was using the website assistant.';
    if (extra) msg += ' ' + extra;
    else if (lastQuery) msg += ' I am looking for: ' + lastQuery;
    var pdp = document.querySelector('[data-khc-pdp] h1');
    if (pdp && !extra) msg += ' (Product page: ' + pdp.textContent.trim() + ')';
    return el('div', { class: 'khc-ai__act' }, [
      el('a', { class: 'khc-ai__btn khc-ai__btn--dark', href: waLink(msg), target: '_blank', rel: 'noopener', text: 'Talk to a human on WhatsApp' }),
      el('a', { class: 'khc-ai__btn', href: CONTACT, text: 'Contact page' })
    ]);
  }
  function actions(list) {
    return el('div', { class: 'khc-ai__act' }, list.map(function (a) { return el('a', { class: 'khc-ai__btn' + (a.dark ? ' khc-ai__btn--dark' : ''), href: a.href, text: a.text }); }));
  }

  /* ---------- confirmed facts (the only non-catalogue answers) ---------- */
  var PRODUCT_WORDS = /\b(laptop|monitor|camera|mouse|keyboard|phone|tv|headphone|console|drone|printer|speaker|projector|earbuds?|microphone|gimbal|lens)/i;
  var FACTS = [
    { s: 1, re: /\b(return|refund|exchange|send (it )?back|money back)\b/i, a: 'We offer 14-day returns, counted from the delivery date. The item has to meet the return conditions. Our team will confirm whether your item qualifies.' },
    { s: 1, re: /\b(pay|payment|cash|cod|credit card|debit card|card payment|visa|mastercard|tabby|tamara|apple pay|google pay|installments?|instalments?|bank transfer)\b/i, a: 'Cash on Delivery is the payment method we currently confirm. For any other payment question, please ask our team.' },
    { s: 1, re: /\b(warrant|guarantee)/i, a: 'Warranty handled by Kherajani. The terms depend on the product, so please ask our team about the exact item you are interested in.' },
    { s: 1, re: /\b(international|abroad|overseas|outside (the )?uae|other countr(y|ies)|ship(ping)? to (other|another|a different) countr|export)/i, a: 'This website currently takes orders for delivery in the United Arab Emirates. For anything outside the UAE, please ask our team.' },
    { s: 1, re: /\b(deliver|delivery|shipping|courier|arrive|how long|when will)\b/i, a: 'Delivery cost and timing depend on your location and the products, so I cannot promise a delivery time here. Send us your area and the product and our team will confirm.' },
    { s: 1, re: /\b(opening hours|working hours|business hours|open(ing)? (time|hours)|what time (do|are) you (open|close)|are you open|closing time)\b/i, a: 'I do not have confirmed opening hours to share here. Please ask our team on WhatsApp before you visit.', addr: 1 },
    { s: 1, re: /\b(where (are|is) (you|your|the (shop|store|showroom))|your (address|location)|shop address|store address|showroom|visit (you|us|the (shop|store))|directions|google maps|how (do|can) i (get|come) to)\b/i, a: 'Our shop address is: ' + ADDRESS + '. Please message us before you visit so we can confirm the item you want is ready.', addr: 1, needAddr: 1 },
    { s: 1, re: /\b(phone number|call you|call us|contact number|your number|mobile number|whatsapp number|e-?mail)\b/i, a: 'You can reach us on WhatsApp at ' + WA_SHOW + (EMAIL ? ' or by email at ' + EMAIL : '') + '.' },
    { s: 1, re: /\b(vat|tax invoice|invoice|trn)\b/i, a: 'Tax and invoice questions are best handled by our team, so they can check your specific order.' },
    { re: /\b(discount|offer|deal|coupon|promo|voucher|sale)\b/i, a: 'I cannot confirm discounts or offers. The price shown on each product is the current price on the website. For a special request, please ask our team.' },
    { re: /\b(order|track|tracking|status|cancel)\b/i, a: 'I cannot see or change orders. Please contact our team with your order number and they will help.' },
    { re: /\b(compatib|works? with|fit[s]? (my|on|with)|support[s]? my)\b/i, a: 'I cannot verify compatibility from here. Please check the product page, or ask our team so they can confirm before you buy.' }
  ];
  var HUMAN = /\b(human|person|agent|support|someone|staff|team|talk|speak|call|whatsapp|contact|help me)\b/i;
  var GREET = /^\s*(hi+|hello+|hey+|hiya|hola|salam|salaam|assalam[a-z ]*|marhaba|good (morning|afternoon|evening)|hi there|hello there)\s*[!.?]*\s*$/i;
  var THANKS = /^\s*(thanks?( you)?|thank you( so much)?|thx|shukran|ok(ay)?|great|perfect|cool)\s*[!.]*\s*$/i;
  var DEVICE_NOTE = /\b(iphone|ipad|galaxy|smart ?phones?|mobile phones?|mobiles?|phones?|tablets?|routers?|smart ?watch(es)?|apple watch)\b/i;

  /* ---------- catalogue search ---------- */
  var STOP = /\b(i|me|my|show|find|need|want|looking|look|for|a|an|the|some|any|please|do|you|have|got|best|good|cheap|cheapest|budget|around|about|with|in|stock|available|to|buy|get|is|are|there|can|what|which|recommend|suggest|something|that|has|of|and|or|under|below|over|aed|dhs|dh|dirhams?|price|less|than|max|maximum|up|within|new|sku|model|part|code|item)\b/gi;
  function parseBudget(q) {
    var num = '([\\d][\\d,]*(?:\\.\\d+)?)\\s*(k)?';
    var cur = '(?:aed|dhs?\\.?|dirhams?)?\\s*';
    function n(v, k) { var x = parseFloat(String(v).replace(/,/g, '')); return k ? x * 1000 : x; }
    var m = q.match(new RegExp('between\\s*' + cur + num + '\\s*(?:and|to|-)\\s*' + cur + num, 'i'));
    if (m) return { min: n(m[1], m[2]), max: n(m[3], m[4]), text: m[0] };
    m = q.match(new RegExp('(?:under|below|less than|max(?:imum)?|up to|within|not more than|upto|<)\\s*' + cur + num, 'i'));
    if (m) return { max: n(m[1], m[2]), text: m[0] };
    m = q.match(new RegExp('(?:over|above|more than|from|at least|>)\\s*' + cur + num, 'i'));
    if (m) return { min: n(m[1], m[2]), text: m[0] };
    return null;
  }
  function terms(q, budget) {
    var s = budget ? q.replace(budget.text, ' ') : q;
    return s.replace(/[?!.,;:()"]/g, ' ').replace(STOP, ' ').replace(/\s+/g, ' ').trim();
  }
  function fetchProducts(q, limit) {
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + (limit || 10) + '&resources[options][unavailable_products]=last';
    return getJSON(url).then(function (d) { return (((d || {}).resources || {}).results || {}).products || []; });
  }
  /* a token that looks like a SKU or model number: has a digit, at least 4 characters */
  function skuTokens(q) {
    return (q.match(/[A-Za-z0-9][A-Za-z0-9._\/-]{3,}/g) || []).filter(function (t) { return /\d/.test(t) && /[A-Za-z]/.test(t) || /^\d{5,}$/.test(t) || /-/.test(t) && /\d/.test(t); });
  }
  function handleOf(url) { var m = String(url || '').match(/\/products\/([^\/?#]+)/); return m ? m[1] : ''; }
  function skuMatch(list, tokens) {
    if (!tokens.length || !list.length) return Promise.resolve(null);
    var top = list.slice(0, 3);
    return Promise.all(top.map(function (pr) {
      var h = handleOf(pr.url); if (!h) return null;
      return getJSON('/products/' + h + '.js').then(function (j) {
        var hit = (j.variants || []).filter(function (v) {
          var s = String(v.sku || '').toLowerCase();
          return s && tokens.some(function (t) { return s === t.toLowerCase(); });
        })[0];
        return hit ? { pr: pr, sku: hit.sku } : null;
      }).catch(function () { return null; });
    })).then(function (r) { return r.filter(Boolean)[0] || null; });
  }
  function searchWithFallback(q) {
    var words = q.split(' ').filter(Boolean);
    function attempt(ws, broad) {
      return fetchProducts(ws.join(' ')).then(function (list) {
        if (list.length || ws.length <= 1) {
          /* a model number in the question that no top result mentions means these are only near matches */
          var hay = list.slice(0, 6).map(function (x) { return ((x.title || '') + ' ' + (x.handle || '')).toLowerCase(); }).join(' ');
          var missing = ws.some(function (w) { return /\d/.test(w) && hay.indexOf(w.toLowerCase()) === -1; });
          return { list: list, broad: broad || (list.length > 0 && missing), q: ws.join(' ') };
        }
        return attempt(ws.slice(1), true);
      });
    }
    return attempt(words, false);
  }
  function normalise(pr) {
    /* products from /search/suggest already have dollars-style prices; /recommendations and /products/x.js give cents */
    return pr;
  }
  function productRow(pr, opts) {
    opts = opts || {};
    pr = normalise(pr);
    var img = pr.featured_image && pr.featured_image.url ? pr.featured_image.url + (pr.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
    var av = pr.available === false || pr.available === 'false' ? 'Sold out' : 'Available to order';
    var pm = parseFloat(pr.price_min), px = parseFloat(pr.price_max);
    var price = (!isNaN(pm) && !isNaN(px) && px > pm ? 'From ' + money(pm) : money(pr.price));
    var link = el('a', { class: 'khc-ai__plink', href: pr.url }, [
      el('span', { class: 'khc-ai__pi' }, [img ? el('img', { src: img, alt: '', width: '56', height: '56', loading: 'lazy' }) : null]),
      el('span', { class: 'khc-ai__pt' }, [
        el('strong', { text: shortTitle(pr.title) }),
        el('span', { text: [pr.vendor, av].filter(Boolean).join(' · ') })
      ]),
      el('span', { class: 'khc-ai__pp', text: price })
    ]);
    var handle = handleOf(pr.url);
    if (!opts.compare || !handle) return el('div', { class: 'khc-ai__p' }, [link]);
    var isChecked = compareSet.some(function (c) { return c.handle === handle; });
    var cbAttrs = { type: 'checkbox', 'data-cmp-handle': handle, 'data-cmp-title': shortTitle(pr.title) };
    if (isChecked) cbAttrs.checked = 'checked';
    var cb = el('label', { class: 'khc-ai__cmpbox' }, [el('input', cbAttrs), el('span', { text: 'Compare' })]);
    return el('div', { class: 'khc-ai__p khc-ai__p--cmp' }, [link, cb]);
  }
  function answerSearch(raw) {
    var budget = parseBudget(raw);
    var t = terms(raw, budget);
    if (!t) {
      bot([p('What kind of product are you looking for? For example a laptop, a monitor, a camera or headphones. You can add a budget, such as “gaming laptop under 5,000”.')]);
      return Promise.resolve();
    }
    lastQuery = raw;
    var wait = bot([el('p', { class: 'khc-ai__typing', text: 'Searching our catalogue…' })]);
    var tokens = skuTokens(raw);
    return searchWithFallback(t).then(function (res) {
      return skuMatch(res.list, tokens).then(function (hit) { res.sku = hit; return res; });
    }).then(function (res) {
      var list = res.list, note = '';
      if (res.sku) {
        drop(wait);
        bot([p('Found by SKU / model code ' + res.sku.sku + ':'), el('div', { class: 'khc-ai__list' }, [productRow(res.sku.pr)]),
          p('Price and availability come from our website. Open the product to see the latest stock status.')]);
        return;
      }
      if (budget) {
        var inb = list.filter(function (x) {
          var pr = parseFloat(x.price_min || x.price);
          return !isNaN(pr) && (budget.max == null || pr <= budget.max) && (budget.min == null || pr >= budget.min);
        });
        if (!inb.length && list.length) {
          var lows = list.map(function (x) { return parseFloat(x.price_min || x.price); }).filter(function (x) { return !isNaN(x); }).sort(function (a, b) { return a - b; });
          drop(wait);
          bot([p('I found matches for “' + res.q + '”, but none at your budget among the top results. The lowest priced one I can see is ' + money(lows[0]) + '.'),
            actions([{ href: SEARCH + '?q=' + encodeURIComponent(res.q) + '&sort_by=price-ascending', text: 'See all, lowest price first' }]), handoff()]);
          return;
        }
        list = inb;
        note = budget.max != null && budget.min != null ? 'Showing top matches between ' + money(budget.min) + ' and ' + money(budget.max) + '.' : (budget.max != null ? 'Showing top matches up to ' + money(budget.max) + '.' : 'Showing top matches from ' + money(budget.min) + '.');
      }
      drop(wait);
      if (!list.length) {
        bot([p('I could not find “' + t + '” in our catalogue. Try another word, or our team can check for you.'),
          actions([{ href: SEARCH + '?q=' + encodeURIComponent(t), text: 'Search the store' }]), handoff()]);
        return;
      }
      var top = list.slice(0, 4);
      var head = res.broad ? 'I could not find an exact match, so these are the closest results for “' + res.q + '”.' : 'Here is what I found for “' + t + '”.';
      var multi = top.length > 1;
      var out = [p(head + (note ? ' ' + note : '') + (multi ? ' Tick Compare under up to 3 results to compare them side by side.' : '')),
        el('div', { class: 'khc-ai__list' }, top.map(function (pr) { return productRow(pr, { compare: multi }); })),
        p('Prices and availability come from our website. Open a product to see the latest stock status.')];
      if (DEVICE_NOTE.test(raw)) out.push(p('For phones, tablets, routers and watches I can only show what is listed on the website right now. Please confirm the exact model with our team before you order.'));
      out.push(actions([{ href: SEARCH + '?q=' + encodeURIComponent(res.q), text: 'See all results' }]));
      if (DEVICE_NOTE.test(raw)) out.push(handoff());
      bot(out);
    }).catch(function () {
      drop(wait);
      bot([p('Sorry, I could not reach the catalogue just now. Please try again, or ask our team.'), handoff()]);
    });
  }

  /* ---------- product comparison (built only from real /products/<handle>.js data) ---------- */
  function fieldRow(label, cells) {
    if (!cells.some(function (c) { return c; })) return null;
    return el('tr', {}, [el('th', { text: label })].concat(cells.map(function (c) { return el('td', { text: c || '—' }); })));
  }
  function answerCompare(items) {
    var wait = bot([el('p', { class: 'khc-ai__typing', text: 'Comparing ' + items.length + ' products…' })]);
    return Promise.all(items.map(function (it) { return getJSON('/products/' + it.handle + '.js').catch(function () { return null; }); })).then(function (list) {
      drop(wait);
      var ok = list.map(function (pr, i) { return pr || { title: items[i].title, _missing: true }; });
      var heads = [el('th', { text: '' })].concat(ok.map(function (pr) { return el('th', { text: shortTitle(pr.title) }); }));
      var rows = [];
      rows.push(fieldRow('Brand', ok.map(function (pr) { return pr.vendor || ''; })));
      rows.push(fieldRow('Price', ok.map(function (pr) {
        if (pr._missing) return '';
        var pm = parseFloat(pr.price_min) / 100, px = parseFloat(pr.price_max) / 100;
        return px > pm ? 'From ' + money(pm) : money(parseFloat(pr.price) / 100);
      })));
      rows.push(fieldRow('Availability', ok.map(function (pr) { return pr._missing ? '' : (pr.available ? 'Available to order' : 'Sold out'); })));
      var optionNames = {};
      ok.forEach(function (pr) { (pr.options || []).forEach(function (o) { if (o && o.name) optionNames[o.name] = true; }); });
      Object.keys(optionNames).forEach(function (nm) {
        rows.push(fieldRow(nm, ok.map(function (pr) {
          var o = (pr.options || []).filter(function (x) { return x.name === nm; })[0];
          return o && o.values ? o.values.join(', ') : '';
        })));
      });
      rows.push(fieldRow('SKU', ok.map(function (pr) {
        var skus = (pr.variants || []).map(function (v) { return v.sku; }).filter(Boolean);
        return skus.length ? skus.slice(0, 2).join(', ') + (skus.length > 2 ? '…' : '') : '';
      })));
      rows = rows.filter(Boolean);
      if (!rows.length) {
        bot([p('I could not load enough details to compare these products. Please open each product page, or ask our team.'), handoff()]);
        return;
      }
      var table = el('table', { class: 'khc-ai__ctable' }, [el('thead', {}, [el('tr', {}, heads)]), el('tbody', {}, rows)]);
      bot([p('Here is a comparison based on our website data. A field left out was not available for these products.'),
        el('div', { class: 'khc-ai__ctablewrap' }, [table]),
        handoff('I would like help choosing between: ' + ok.map(function (pr) { return pr.title; }).join(', '))]);
    }).catch(function () {
      drop(wait);
      bot([p('I could not load the comparison just now. Please try again, or ask our team.'), handoff()]);
    });
  }
  function clearCompareSelections() {
    compareSet = [];
    [].forEach.call(log.querySelectorAll('input[data-cmp-handle]:checked'), function (cb) { cb.checked = false; });
    updateCompareBar();
  }
  function updateCompareBar() {
    var n = compareSet.length;
    if (!n) { compareBar.hidden = true; return; }
    compareBar.hidden = false;
    compareCount.textContent = n + (n === 1 ? ' product selected (choose at least 2)' : ' products selected');
    compareGoBtn.disabled = n < 2;
  }

  /* ---------- product-page answers (read from the store's own product data) ---------- */
  function onPdp() { return !!document.querySelector('[data-khc-pdp]'); }
  function pdpProduct() {
    if (pdpCache) return pdpCache;
    var url = location.pathname.replace(/\/+$/, '') + '.js';
    pdpCache = getJSON(url).catch(function (e) { pdpCache = null; throw e; });
    return pdpCache;
  }
  function textOfHtml(html) {
    var d = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    var lis = [].map.call(d.querySelectorAll('li'), function (li) { return li.textContent.replace(/\s+/g, ' ').trim(); }).filter(function (s) { return s.length > 3 && s.length < 220; });
    var plain = (d.body.textContent || '').replace(/\s+/g, ' ').trim();
    return { lis: lis, plain: plain };
  }
  function answerThisProduct() {
    var h1 = document.querySelector('[data-khc-pdp] h1');
    if (!h1) return false;
    var stock = document.querySelector('[data-khc-stock] span');
    var price = document.querySelector('[data-khc-price]');
    var sel = [].map.call(document.querySelectorAll('[data-khc-pdp] .khc-opt'), function (f) {
      var l = f.querySelector('legend'), s = f.querySelector('[data-khc-sel]');
      return l && s ? l.childNodes[0].textContent.trim() + ': ' + s.textContent.trim() : '';
    }).filter(Boolean).join(', ');
    var st = stock ? stock.textContent.trim() : '';
    var out = shortTitle(h1.textContent) + (sel ? ' (' + sel + ')' : '') + '. ';
    if (price) out += 'Price: ' + price.textContent.replace(/\s+/g, ' ').trim() + '. ';
    if (st) out += 'Stock status: ' + st + '.';
    var extra = st === 'Availability to be confirmed' ? ' That means our team needs to check the stock for this item before you order.' : '';
    bot([p(out + extra), handoff('I have a question about this product: ' + h1.textContent.trim())]);
    return true;
  }
  function answerSpecs() {
    var wait = bot([el('p', { class: 'khc-ai__typing', text: 'Reading the product details…' })]);
    return pdpProduct().then(function (pr) {
      drop(wait);
      var d = textOfHtml(pr.description);
      var nodes = [p(shortTitle(pr.title) + (pr.vendor ? ' by ' + pr.vendor : '') + '.')];
      var skus = (pr.variants || []).map(function (v) { return v.sku; }).filter(Boolean);
      if (d.lis.length) {
        nodes.push(p('Details listed on the product page:'));
        nodes.push(el('ul', { class: 'khc-ai__ul' }, d.lis.slice(0, 6).map(function (s) { return el('li', { text: s }); })));
      } else if (d.plain) {
        nodes.push(p(d.plain.length > 420 ? d.plain.slice(0, 420).replace(/\s+\S*$/, '') + '…' : d.plain));
      } else {
        nodes.push(p('This product page does not list detailed specifications yet, so I cannot state them. Our team can confirm the exact specs for you.'));
      }
      if (skus.length) nodes.push(p('SKU: ' + skus.slice(0, 3).join(', ') + (skus.length > 3 ? ' and more' : '') + '.'));
      nodes.push(p('The full description is further down this page. I only repeat what the page already says.'));
      nodes.push(handoff('I have a question about the specs of: ' + pr.title));
      bot(nodes);
    }).catch(function () { drop(wait); bot([p('I could not read the product details just now. Please scroll down this page, or ask our team.'), handoff()]); });
  }
  function answerVariants() {
    var wait = bot([el('p', { class: 'khc-ai__typing', text: 'Checking the options…' })]);
    return pdpProduct().then(function (pr) {
      drop(wait);
      var vs = pr.variants || [];
      if (vs.length <= 1) {
        bot([p('This product has a single option: ' + money(vs[0] ? vs[0].price / 100 : pr.price / 100) + (vs[0] && vs[0].available === false ? ', currently sold out.' : ', available to order.')), handoff('I have a question about: ' + pr.title)]);
        return;
      }
      var rows = vs.slice(0, 8).map(function (v) {
        return el('li', {}, [el('span', { text: v.title }), el('span', { text: money(v.price / 100) + (v.available ? '' : ' · Sold out') })]);
      });
      bot([p('This product comes in ' + vs.length + ' options. Choose one on the page to see its exact price and stock:'),
        el('ul', { class: 'khc-ai__kv' }, rows),
        vs.length > 8 ? p('Showing the first 8. The rest are on the product page.') : null,
        handoff('I have a question about the options of: ' + pr.title)]);
    }).catch(function () { drop(wait); bot([p('I could not read the options just now. Please check the selector on this page, or ask our team.'), handoff()]); });
  }
  function recRow(r) {
    return productRow({
      title: r.title, url: r.url, vendor: r.vendor, available: r.available,
      price: (parseFloat(r.price) / 100), price_min: (parseFloat(r.price_min) / 100), price_max: (parseFloat(r.price_max) / 100),
      featured_image: r.featured_image ? { url: typeof r.featured_image === 'string' ? r.featured_image : r.featured_image.url } : null
    });
  }
  function answerRelated() {
    var wait = bot([el('p', { class: 'khc-ai__typing', text: 'Looking for related products…' })]);
    return pdpProduct().then(function (pr) {
      return getJSON('/recommendations/products.json?product_id=' + pr.id + '&limit=4&intent=related').then(function (d) {
        drop(wait);
        var list = (d && d.products) || [];
        if (!list.length) {
          bot([p('I could not find related products for this item. Our team can suggest accessories that suit it.'), handoff('I would like accessories for: ' + pr.title)]);
          return;
        }
        bot([p('Our store suggests these related products. They are suggestions, not a compatibility check, so please confirm with our team if you are unsure.'),
          el('div', { class: 'khc-ai__list' }, list.slice(0, 4).map(recRow)),
          handoff('I would like to confirm accessories for: ' + pr.title)]);
      });
    }).catch(function () { drop(wait); bot([p('I could not load related products just now. Please ask our team.'), handoff()]); });
  }
  function answerCart() {
    var wait = bot([el('p', { class: 'khc-ai__typing', text: 'Checking your cart…' })]);
    return getJSON(CART_URL + '.js').then(function (c) {
      drop(wait);
      if (!c.item_count) {
        bot([p('Your cart is empty right now.'), actions([{ href: '/', text: 'Keep shopping' }])]);
        return;
      }
      var names = c.items.slice(0, 3).map(function (i) { return i.quantity + ' × ' + shortTitle(i.product_title); });
      bot([p('You have ' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in your cart, subtotal ' + money(c.total_price / 100) + '.'),
        el('ul', { class: 'khc-ai__ul' }, names.map(function (n) { return el('li', { text: n }); })),
        c.items.length > 3 ? p('and ' + (c.items.length - 3) + ' more.') : null,
        p('Shipping and any other charges are calculated at checkout. Cash on Delivery is available.'),
        actions([{ href: CART_URL, text: 'View cart' }, { href: CHECKOUT_URL, text: 'Go to checkout', dark: true }])]);
    }).catch(function () { drop(wait); bot([p('I could not read your cart just now. You can open it from the bag icon at the top.')]); });
  }

  /* ---------- routing ---------- */
  function route(raw) {
    var q = raw.trim();
    if (!q) return Promise.resolve();
    you(q);
    if (GREET.test(q)) { bot([p('Hello! What are you looking for today? You can pick a topic below or type a product name, a model, a SKU or a budget.')]); return Promise.resolve(); }
    if (THANKS.test(q)) { bot([p('You are welcome. If you need anything else, I am here, and our team is on WhatsApp too.')]); return Promise.resolve(); }
    if (/\b(my cart|in (my )?cart|cart total|basket|what did i add)\b/i.test(q)) return answerCart();
    var factS = FACTS.some(function (f) { return f.s && f.re.test(q); });
    if (onPdp() && !factS) {
      if (/\b(spec|specs|specification|specifications|features?|details?|description|what.?s (in|included)|about (this|it))\b/i.test(q)) return answerSpecs();
      if (/\b(variants?|options?|colou?rs?|sizes?|versions?|storage|capacity|configurations?)\b/i.test(q)) return answerVariants();
      if (/\b(accessor(y|ies)|related|goes? with|go with|add-?ons?|bundle|what else|also need|pair)\b/i.test(q)) return answerRelated();
      if (/\b(this (product|item)|is (it|this) in stock|in stock\??|how much|price)\b/i.test(q) && answerThisProduct()) return Promise.resolve();
    }
    for (var i = 0; i < FACTS.length; i++) {
      var f = FACTS[i];
      if (f.re.test(q) && (f.s || !PRODUCT_WORDS.test(q))) {
        if (f.needAddr && !ADDRESS) continue;
        var nodes = [p(f.a)];
        if (f.addr && ADDRESS && !f.needAddr) nodes.push(p('Our shop address is: ' + ADDRESS + '.'));
        nodes.push(handoff());
        bot(nodes);
        return Promise.resolve();
      }
    }
    if (HUMAN.test(q) && q.split(/\s+/).length <= 8) {
      bot([p('Of course. A member of our team can help you directly.'), handoff()]);
      return Promise.resolve();
    }
    return answerSearch(q);
  }

  function submit(text) {
    if (busy) return;
    busy = true;
    var done = function () { busy = false; };
    try { route(text).then(done, done); } catch (e) { done(); }
  }

  /* ---------- open / close / minimize ---------- */
  function setMin(min) {
    root.classList.toggle('is-min', min);
    if (minBtn) minBtn.setAttribute('aria-label', min ? 'Restore the assistant' : 'Minimize the assistant');
  }
  function setOpen(open) {
    root.classList.toggle('is-open', open);
    if (!open) root.classList.remove('is-min');
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      setTimeout(function () {
        var target = (home.hidden || !homeInput) ? input : homeInput;
        if (target) target.focus({ preventScroll: true });
      }, 60);
    }
  }
  fab.addEventListener('click', function () {
    if (root.classList.contains('is-open') && root.classList.contains('is-min')) { setMin(false); return; }
    setOpen(!root.classList.contains('is-open'));
  });
  var closeBtn = root.querySelector('[data-ai-close]');
  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(false); fab.focus(); });
  if (minBtn) minBtn.addEventListener('click', function (e) { e.stopPropagation(); setMin(!root.classList.contains('is-min')); });
  if (hd) hd.addEventListener('click', function (e) {
    if (root.classList.contains('is-min') && !e.target.closest('[data-ai-min]') && !e.target.closest('[data-ai-close]')) setMin(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) { setOpen(false); fab.focus(); }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-khc-ai-open]') : null;
    if (t) { e.preventDefault(); setOpen(true); return; }
    if (root.classList.contains('is-open') && !root.contains(e.target)) setOpen(false);
  });

  /* ---------- home dashboard interactions ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ai-home-btn]')) showHome();
  });
  home.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-q]');
    if (!b) return;
    showLog();
    submit(b.getAttribute('data-q'));
  });
  if (homeForm) homeForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = homeInput.value; homeInput.value = '';
    if (v.trim()) { showLog(); submit(v); }
  });
  if (budgetBtn) budgetBtn.addEventListener('click', function () {
    homeInput.value = 'under AED ';
    homeInput.focus();
    if (homeInput.setSelectionRange) homeInput.setSelectionRange(homeInput.value.length, homeInput.value.length);
  });
  if (compareIntroBtn) compareIntroBtn.addEventListener('click', function () {
    showLog();
    bot([p('Search for two or three products, for example “laptop” or “camera”. Under each result you will see a Compare checkbox: select up to 3, then tap Compare.')]);
  });

  /* ---------- compare bar ---------- */
  log.addEventListener('change', function (e) {
    var cb = e.target.closest('input[data-cmp-handle]');
    if (!cb) return;
    var h = cb.getAttribute('data-cmp-handle'), title = cb.getAttribute('data-cmp-title');
    if (cb.checked) {
      if (compareSet.length >= 3) { cb.checked = false; bot([p('You can compare up to 3 products at a time. Remove one before adding another.')]); return; }
      if (!compareSet.some(function (c) { return c.handle === h; })) compareSet.push({ handle: h, title: title });
    } else {
      compareSet = compareSet.filter(function (c) { return c.handle !== h; });
    }
    updateCompareBar();
  });
  if (compareClearBtn) compareClearBtn.addEventListener('click', clearCompareSelections);
  if (compareGoBtn) compareGoBtn.addEventListener('click', function () {
    if (compareSet.length < 2) return;
    var items = compareSet.slice();
    clearCompareSelections();
    showLog();
    answerCompare(items);
  });

  /* ---------- quick-repeat chips (shown while a conversation is in progress) ---------- */
  chipsBox.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-q]');
    if (!b) return;
    submit(b.getAttribute('data-q'));
    input.focus({ preventScroll: true });
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value; input.value = '';
    if (v.trim()) { showLog(); submit(v); }
  });
  if (onPdp() && pdpSection) pdpSection.hidden = false;
})();
